import Container from 'core/display/Container'
import Spine from 'core/display/Spine'
import { signal } from 'services/SignalsService'
import { animations } from 'settings/custom/win'
import { create } from 'utils/Object'

export default class BonusNameSpine extends Container {
  constructor(data) {
    super()

    this.ori = null
    this._data = data
    const spine = this.spine  = new Spine(create(this._data, animations.bonusNames))
    this.spine.scale.set(data.scale ? data.scale : 1)
    this.addChild(spine)
    this.createSignal()

  }

  createSignal() {
    const self = this

    signal.on('STATE:IN:FS-START', this.animate.bind(this))
    signal.on('STATE:IN:FS-END', () => this.spine.visible = false)
    signal.on('RESIZE', async function ({ orientation }) {
      self.ori = orientation
      self.animate()
    })
  }

  animate() {
    const action = game.models.SpinModel.get().action
    if(action === 'spin' || action === 'freebet'){
      this.spine.play(`${'fsProgressiveMultiplier'}-${this.ori}`, false)
      return
    }
    this.spine.visible = true

    this.spine.play(`${action}-${this.ori}`, false)
  }
}
